import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const Sites = createSlice({
  name: "Sites",
  initialState: {
    sitesTableData: [],
  },
  reducers: {
    ReducerTableData: (state: any, action: any) => {
      state.sitesTableData = action.payload;
      return state;
    },
    ReducerAddTableData: (state: any, action: any) => {
      state.sitesTableData = action.payload;
      return state;
    },
  },
});

export const { ReducerTableData, ReducerAddTableData } = Sites.actions;

export default Sites;
